let stadigurl = 'https://stadig.ifeng.com/appsta.js?datatype=newsappsns';
const videoAppStadigurl = 'http://stadig.ifeng.com/appsta.js?datatype=videoappsns';
// 浏览器ua
const ua = typeof navigator === 'object' ? navigator.userAgent : '';

// cookie
const cookieUtil = {
    set: (name, value, expires, path, domain, secure) => {
        let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

        if (expires instanceof Date) {
            cookieText = `${cookieText};expires=${expires.toGMTString()}`;
        }
        if (path) {
            cookieText = `${cookieText};path=${path}`;
        }
        if (domain) {
            cookieText = `${cookieText};domain${domain}`;
        }
        if (secure) {
            cookieText = `${cookieText};secure`;
        }
        document.cookie = cookieText;
    },
    get: name => {
        const cookieName = `${encodeURIComponent(name)}=`;
        const cookieStart = document.cookie.indexOf(cookieName);
        let cookieValue = null;

        if (cookieStart > -1) {
            let cookieEnd = document.cookie.indexOf(';', cookieStart);

            if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
            }
            cookieValue = document.cookie.substring(cookieStart + cookieName.length, cookieEnd);
            cookieValue = decodeURIComponent(cookieValue);
        }

        return cookieValue;
    },
};

// 手机操作系统
const mos = () => {
    if (ua.match(/iphone|ipod/gi) || ua.match(/ipad/gi)) {
        return 'iphone';
    } else if (ua.match(/android/gi)) {
        return 'android';
    } else {
        return 'windows';
    }
};

// 获取广告的userkey
const userkeyUtil = {
    get: l => {
        const len = l || 32;
        const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        const charsLen = chars.length;
        let uid = '';

        for (let i = 0; i < len; i++) {
            uid += chars.charAt(Math.floor(Math.random() * charsLen));
        }

        return uid;
    },
    init: () => {
        if (cookieUtil.get('userkey')) {
            return cookieUtil.get('userkey');
        } else {
            const uid = userkeyUtil.get(15);
            const exp = new Date();

            exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
            cookieUtil.set('userkey', uid, exp, '/');

            return uid;
        }
    },
};

// 分享来源
const sharefrom = () => {
    if (ua.match(/MicroMessenger/gi)) {
        return 'wx';
    } else if (ua.match(/QQ\//)) {
        return 'qq';
    } else if (ua.match(/WeiBo/i)) {
        return 'weibo';
    } else {
        return 'unknown';
    }
};

// 个位数时间补零
const format = n => {
    return n > 9 ? n : `0${n}`;
};

// 时间戳
const timestamp = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = format(now.getMonth() + 1);
    const day = format(now.getDate());
    const hour = format(now.getHours());
    const min = format(now.getMinutes());
    const sec = format(now.getSeconds());
    // 输出格式为2016-05-27+09:04:36
    const t = `${year}-${month}-${day}+${hour}:${min}:${sec}`;

    return now ? t : '';
};

// session字段,必须encode
const session = (behavior, type, other) => {
    // behavior是必要参数 page 或 action
    // type 是必要参数

    // other 是其他统计字段，类型是对象
    // 遍历对象
    const typeVal = type ? `type=${type}` : '';
    let params = '';

    if (typeof other == 'object') {
        const o = other;

        for (const n in o) {
            params += `$${n}=${o[n]}`;
        }
    }

    const s = `${timestamp()}#${behavior}#${typeVal}${params}`;

    return s;
};

/**
 * 发送统计
 * config是数组类型里的对象
 * config=[{
 *  behavior: 'page',
 *  type: 'h5',
 *  other: {
 *      id: 'ucms_7jJrbn1ffO6',
 *      url: location.href,
 *      ref: document.referrer
 *  }
 * },{
 *  behavior: 'action',
 *  type: 'doc',
 *  other: {
 *      id: 'ucms_7jJrbn1ffO6',
 *      url: location.href,
 *      ref: document.referrer
 *  }
 * }]
 *  */

const h5PageCount = (config, shareName) => {
    const sessionArr = [];

    config.forEach(item => {
        if (item && item.datatype) {
            stadigurl = `https://stadig.ifeng.com/appsta.js?datatype=${item.datatype}`;
        }
        sessionArr.push(session(item.behavior, item.type, item.other));
    });

    const allSession = sessionArr.join('@');
    const share = shareName || sharefrom();
    const stastring = `${stadigurl}&mos=${mos()}&userkey=${userkeyUtil.init()}&ua=&share=${share}&session=${encodeURIComponent(
        allSession,
    )}`;
    const script = document.createElement('script');

    script.src = stastring;
    script.async = 'async';
    document.body.appendChild(script);
};

/**
 * 视频客户端发送统计发放
 * @param {Array} config
 */
const videoAppPageCount = config => {
    const sessionArr = [];

    config.forEach(item => {
        sessionArr.push(session(item.behavior, item.type, item.other));
    });

    const allSession = sessionArr.join('@');
    const stastring = `${videoAppStadigurl}&mos=${mos()}&userkey=${userkeyUtil.init()}&ua=&share=${sharefrom()}&session=${encodeURIComponent(
        allSession,
    )}`;
    const script = document.createElement('script');

    script.src = stastring;
    script.async = 'async';
    document.body.appendChild(script);
};

/**
 * wap_act统计发放
 * @param {object} config
 */
const wapactPageCount = config => {
    const wapactStadigurl = 'https://stadig.ifeng.com/actsta.js';
    const wapactStadigurlNew = 'https://stadig0.ifeng.com/actsta.js';
    const value = config.value || '';
    const uri = encodeURIComponent(location.href) || '';
    const ref = encodeURIComponent(document.referrer) || '';
    const uid = cookieUtil.get('userid') || '';
    const sid = config.sid || '';
    const time = new Date().getTime();
    const ci = config.ci || '';
    const pt = config.pt || '';
    const method = config.method || 'post';
    const stastring = `datatype=wap_act&value=${value}&uri=${uri}&ref=${ref}&uid=${uid}&sid=${sid}&time=${time}&ci=${ci}&pt=${pt}`;
    const script = document.createElement('script');

    script.src = `${wapactStadigurl}?${stastring}`;
    script.async = 'async';

    if (method === 'get') {
        document.body.appendChild(script);
    }

    if (method === 'post' && navigator && navigator.sendBeacon) {
        navigator.sendBeacon(wapactStadigurlNew, stastring);
    } else {
        document.body.appendChild(script);
    }
};

export { h5PageCount, cookieUtil, mos, sharefrom, userkeyUtil, videoAppPageCount, wapactPageCount };
